<template>
  <div>
    <xm-dialog title="导出历史" width="900px" @close-dialog="closeFunc">
      <div class="content">
        <xm-table
          :isCheckbox="false"
          :tableFiled="tableConfig"
          :table="exportList"
        >
          <div slot="operaSlot" slot-scope="{ row }">
            <span
              v-if="row.row.status_name == '已完成'"
              @click="handlerDown(row.row)"
              class="down-style"
            >
              文件下载
            </span>
          </div>
        </xm-table>
        <div class="page-model">
          <XmPaged
            :pagesize="pageSize"
            :pages="pages"
            :total="total"
            @go-pages="gopage"
          ></XmPaged>
        </div>
      </div>
    </xm-dialog>
  </div>
</template>
<script>
import { getExportTaskList } from '@/utils/api/common.js';
export default {
  name: 'PublicExportHistory',
  props: {
    // 导出类型(后端决定)：既参与接口请求，又在未传 fileName 时作为文件名映射 key
    type: {
      type: [Number, String],
      default: 2,
    },
    // 每页大小
    pageSize: {
      type: Number,
      default: 12,
    },
    // 自定义下载文件名：传了则用该名字，不传则按 type 走 FILE_NAME_CONFIG 映射
    fileName: {
      type: String,
      default: '',
    },
    // 自定义接口函数，签名：(params: Object) => Promise；不传则走默认的 getExportTaskList
    apiFunc: {
      type: Function,
      default: null,
    },
    // 自定义接口请求参数：会与内部默认参数(type/pageSize/pageNum/MUTE_WARNING)合并，键冲突时以 extraParams 为准
    extraParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      exportList: [], // 导出列表
      tableConfig: [
        {
          text: '任务创建时间',
          filed: 'creation_time',
          width: '185px',
          isSort: false,
        },
        {
          text: '任务ID',
          filed: 'task_id',
          width: '185px',
          isSort: false,
        },
        {
          text: '导出申请人',
          filed: 'export_applicant',
          width: '185px',
          isSort: false,
        },
        {
          text: '任务状态',
          filed: 'status_name',
          width: '185px',
          isSort: false,
        },
        {
          text: '操作',
          filed: 'opera',
          width: '120px',
          isSort: false,
          isEdit: true,
        },
      ],
      total: 0, // 总数
      pages: 1, // 当前页码
    };
  },
  mounted() {
    this.fetchExportList();
  },
  methods: {
    /**
     * 拉取导出任务列表
     * 默认参数：type / pageSize / pageNum / MUTE_WARNING
     * 若传入 apiFunc 则用 apiFunc 发起请求，否则用默认 getExportTaskList
     * 若传入 extraParams 则合并到请求参数中(优先级高于默认参数)
     */
    fetchExportList() {
      const option = {
        type: this.type,
        pageSize: this.pageSize,
        pageNum: this.pages,
        MUTE_WARNING: 1,
      };
      Object.assign(option, this.extraParams || {});
      const requestFn = this.apiFunc || getExportTaskList;
      requestFn(option)
        .then((res) => {
          if (res.code == 200) {
            this.exportList = res.data.list;
            this.total = res.data.total;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    /**
     * 文件下载
     * 文件名优先级：fileName prop > FILE_NAME_CONFIG[type] > 空串
     */
    handlerDown(rowInfo) {
      const curfileName = this.publicSetFileName(
        rowInfo.url,
        this.fileName,
        this.type
      );
      this.down(rowInfo.url, curfileName);
    },
    gopage(page) {
      this.pages = Number(page);
      this.fetchExportList();
    },
    closeFunc() {
      this.$emit('closeHistory');
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 900px;
  box-sizing: border-box;
  padding: 20px;
  .page-model {
    display: flex;
    justify-content: center;
    margin: 25px auto 10px auto;
  }

  .down-style {
    text-decoration: none;
    color: #026bff;
    cursor: pointer;
  }
}
</style>
